import { useSelector } from "react-redux";
import { selectMap } from "../../features/counter/counterSlice";
import { MenuItem } from "./MenuItem";
import style from "./GuidelineNav.module.scss";
import icons from "../../scss/guidelineicons.module.scss";
import { filterMenuItems } from "./filterMenuItems";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import generateMenuFromXml from "./guidelineMenuGenerator";

const GuidelineNavWeb = ({glObj}) => {
  const dartMap = useSelector(selectMap);
  const navigate = useNavigate();
  if (!glObj) {
    return null;
  }
  const parsed = generateMenuFromXml(`${dartMap}`);
  const { menuItems, rootGuideline, glInfo } = filterMenuItems({
    glObj,
    menuJson: parsed,
  });

  const iconClass = classNames(
    icons.squareIcon,
    icons.iconSize32,
    icons[glInfo.iconClassSuffix],
  );

  const topicMenus = menuItems?.items.filter(
    (props) => !props.msPath?.includes("-tables-boxes-figures"),
  );
  const chapterRoot = glObj.glPage.replaceAll(" ", "_");
  const goTopic = () => {
    navigate(`/guidelines/${chapterRoot}`);
  };

  // convert the guideline base path for quick links
  const getBaseInPath = (base) => {
    return base === "quicklinks"
      ? glInfo.onClickProps.replaceAll(" ", "_")
      : base;
  };

  return (
    <div>
      <Helmet>
        <title>{menuItems.title}</title>
      </Helmet>
      <div className={style.header}>
        {rootGuideline && <div className={iconClass} role="img"></div>}
        <h3
          className={`${rootGuideline ? "size-20" : "size-36"} semibold`}
          onClick={goTopic}
        >
          {menuItems.title}
        </h3>
      </div>

      <div>
        {topicMenus?.map((props, index) => (
          <MenuItem
            {...props}
            key={`menu-${index}`}
            base={getBaseInPath(glObj.glPage)}
            hasIconOption={false}
          ></MenuItem>
        ))}
      </div>
    </div>
  );
};

GuidelineNavWeb.propTypes = {
  glObj: PropTypes.object.isRequired,
};

export default GuidelineNavWeb;